import type React from "react";

import { Stack } from "@mui/material";

import { WidgetBox } from "shared/containers/WidgetBox";

import { SkeletonLayout } from "../SkeletonLayout";

export const CommentSkeleton: React.FC = () => {
  return (
    <WidgetBox
      icon={<SkeletonLayout layout={{ type: "skeleton", variant: "circular", width: "20px", height: "20px" }} />}
      smallPadding
      bordered
      title={
        <SkeletonLayout
          layout={{ type: "skeleton", variant: "text", width: "120px", typographyVariant: "body_bold" }}
        />
      }
      toolbar={
        <Stack direction="row" gap={1} alignItems="center">
          <SkeletonLayout
            layout={{ type: "skeleton", variant: "text", width: "80px", typographyVariant: "subtitle1" }}
          />
          <SkeletonLayout layout={{ type: "skeleton", variant: "rounded", width: "40px", height: "20px" }} />
        </Stack>
      }
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <SkeletonLayout layout={{ type: "skeleton", variant: "text", width: "70%", typographyVariant: "subtitle1" }} />
        <SkeletonLayout layout={{ type: "skeleton", variant: "rounded", width: "90px", height: "32px" }} />
      </Stack>
    </WidgetBox>
  );
};
